import Repository from "@/utils/API/Repository";
import { AxiosResponse } from "axios";
import { TrialRestaurantMetadataDto } from "@/models/Restaurants/TrialRestaurantMetadataDto";
import { UpdateTrialRestaurantActivityDto } from "@/models/Restaurants/UpdateTrialRestaurantActivityDto";
import { BookDemoRequestDto } from "@/models/Restaurants/BookDemoRequestDto";

export const resource = '/restaurants';

export default {
  getCurrentTrialMetadata(): Promise<AxiosResponse<TrialRestaurantMetadataDto>> {
    return Repository.get<TrialRestaurantMetadataDto>(
      `${resource}/TrialMetadata/Current`,
      { withCredentials: true }
    );
  },
  updateCurrentTrialActivity(
    dto: UpdateTrialRestaurantActivityDto
  ): Promise<AxiosResponse<TrialRestaurantMetadataDto>> {
    return Repository.patch<UpdateTrialRestaurantActivityDto, AxiosResponse<TrialRestaurantMetadataDto>>(
      `${resource}/TrialMetadata/Current/Activity`,
      dto,
      { withCredentials: true }
    );
  },
  getTrialMetadata(restaurantId: number): Promise<AxiosResponse<TrialRestaurantMetadataDto>> {
    return Repository.get<TrialRestaurantMetadataDto>(
      `${resource}/${restaurantId}/TrialMetadata`,
      { withCredentials: true }
    );
  },
  updateTrialActivity(
    restaurantId: number,
    dto: UpdateTrialRestaurantActivityDto
  ): Promise<AxiosResponse<TrialRestaurantMetadataDto>> {
    return Repository.patch<UpdateTrialRestaurantActivityDto, AxiosResponse<TrialRestaurantMetadataDto>>(
      `${resource}/${restaurantId}/TrialMetadata/Activity`,
      dto,
      { withCredentials: true }
    );
  },
  listTrialMetadata(): Promise<AxiosResponse<TrialRestaurantMetadataDto[]>> {
    return Repository.get<TrialRestaurantMetadataDto[]>(
      `${resource}/TrialMetadata`,
      { withCredentials: true }
    );
  },
  updateRestaurantBrandingLogo(logoImageBase64: string) {
    return Repository.post(
      `${resource}/UpdateRestaurantBranding`,
      { brandImageBase64: logoImageBase64 },
      { withCredentials: true }
    );
  },
  bookDemoRequest(dto: BookDemoRequestDto): Promise<AxiosResponse<void>> {
    return Repository.post<BookDemoRequestDto, AxiosResponse<void>>(
      `${resource}/RequestDemo`,
      dto,
      { withCredentials: true }
    );
  }
};